export const STORAGE_KEY_LOGIN_CLICKED = 'loginClicked';
export enum TrackingValue {
  SITE_OPERATIONS = 'SiteOperations',
  MAIN_NAVIGATION = 'MainNavigation'
}
